import { useMutation } from '@apollo/client';
import { gql } from '__generated__';
import { FC } from 'react';

import ConfirmButton from 'components/ConfirmButton';

const REMOVE_DEPARTMENT_ADMIN_MUTATION = gql(`
  mutation RemoveDepartmentAdmin($id: ID!) {
    removeDepartmentAdmin(id: $id) {
      id
    }
  }
`);

const RemoveDepartmentAdminDialogButton: FC<{ id: string; onComplete: () => void }> = ({
  id,
  onComplete,
}) => {
  const [removeDepartmentAdmin, { loading, error }] = useMutation(
    REMOVE_DEPARTMENT_ADMIN_MUTATION,
    {
      variables: {
        id,
      },
      refetchQueries: ['DepartmentAdmins'],
      onCompleted: onComplete,
    }
  );

  return (
    <ConfirmButton onConfirm={removeDepartmentAdmin} loading={loading} error={error}>
      Remove Department Admin
    </ConfirmButton>
  );
};

export default RemoveDepartmentAdminDialogButton;
